import React, {PureComponent} from 'react';
import {TopIcon} from './ToTheTop.style';

export default class ToTheTop extends PureComponent {
  goTop = () => window && window.scrollTo(0, 0);
  render() {
    return <TopIcon onClick={this.goTop} />;
  }
}
